import { useEffect, useState } from "react";

// Ticks state every 60s so any component showing computed dispatch dates
// (e.g. "17 AUG – 25 AUG") refreshes if the tab stays open across midnight.
export default function useAvailabilityTick() {
  const [dateTick, setDateTick] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setDateTick(Date.now()), 60_000);
    return () => clearInterval(id);
  }, []);
  return dateTick;
}
